/**
 * Portal Manta · Wrapper HTML Manta · usado para exportar relatórios
 * Gera HTML standalone com cabeçalho Manta, CSS inline e marca d'água
 */
import { M, F } from '../tokens/theme.js';

export function wrapHtmlManta(titulo, corpoHTML, options = {}) {
  const meta = options.meta || '';
  const data = new Date().toLocaleDateString('pt-BR');

  return `<!DOCTYPE html>
<html lang="pt-BR">
<head>
<meta charset="UTF-8"/>
<title>${titulo}</title>
<style>
  * { box-sizing: border-box; }
  body { font-family: 'Segoe UI', system-ui, sans-serif; margin: 0;
    padding: 28px; color: ${M.text}; background: ${M.bgAlt}; line-height: 1.55; }
  .container { max-width: 1100px; margin: 0 auto; background: #fff;
    border: 1px solid ${M.border}; border-radius: 6px; overflow: hidden; }
  .hero { padding: 22px 30px; background: ${M.title}; color: #fff;
    border-bottom: 3px solid ${M.accent}; }
  .hero h1 { font-size: 20px; margin: 0; }
  .hero .meta { font-family: monospace; font-size: 10.5px; color: #FCD34D;
    margin-top: 4px; letter-spacing: 0.5px; }
  .content { padding: 22px 30px; }
  h2 { font-size: 14px; color: ${M.title}; padding: 6px 12px;
    background: ${M.bgAlt}; border-left: 3px solid ${M.accent};
    margin: 18px 0 10px; }
  table { width: 100%; border-collapse: collapse; margin: 8px 0; font-size: 11.5px; }
  th { padding: 7px 10px; background: ${M.title}; color: #fff; text-align: left;
    font-family: monospace; font-size: 10px; letter-spacing: 0.4px;
    text-transform: uppercase; border-bottom: 2px solid ${M.accent}; }
  td { padding: 5px 10px; border-top: 1px solid ${M.borderSoft}; }
  tr:nth-child(even) td { background: #FAFBFC; }
  .kpi-card { display: inline-block; padding: 8px 12px; margin: 4px;
    background: #fff; border: 1px solid ${M.border};
    border-left: 3px solid ${M.accent}; border-radius: 3px; }
  .kpi-card .l { font-family: monospace; font-size: 9.5px;
    color: ${M.muted}; text-transform: uppercase; letter-spacing: 0.5px; }
  .kpi-card .v { font-size: 16px; font-weight: 700; color: ${M.title}; }
  .kpi-card .u { font-size: 10px; color: ${M.muted}; margin-left: 2px; }
  .badge { padding: 1px 6px; font-family: monospace; font-size: 9px;
    font-weight: 700; border-radius: 2px; }
  .b-manual { background: #F3F4F6; color: #6B7280; }
  .b-preset { background: #FEF3C7; color: #92400E; }
  .b-import { background: #DBEAFE; color: #1E40AF; }
  .b-extraido { background: #D1FAE5; color: #065F46; }
  .footer { padding: 12px 30px; background: ${M.title}; color: #D1D5DB;
    text-align: center; font-family: monospace; font-size: 10px;
    letter-spacing: 0.5px; }
  .footer .logo { color: ${M.accent}; font-weight: 700; }
  @media print {
    body { padding: 0; background: #fff; }
    .container { border: none; box-shadow: none; }
  }
</style>
</head>
<body>
<div class="container">
  <div class="hero">
    <h1>${titulo}</h1>
    <div class="meta">📅 ${data}${meta ? ' · ' + meta : ''} · Portal Manta v29</div>
  </div>
  <div class="content">${corpoHTML}</div>
  <div class="footer">
    <span class="logo">MANTA ASSOCIADOS</span> · Consultoria de Infraestrutura
  </div>
</div>
</body>
</html>`;
}

export default wrapHtmlManta;
